module.exports = __webpack_public_path__ + "static/media/LogoNotAGame.41acf81e.svg";